$(document).on('click', '[data-collapse-toggle]', function() {
  $($(this).attr('data-collapse-toggle')).toggleClass('hidden');
});
